import { VALAQUENTA_API_URL } from "../..";
import { authorizedAxios } from "../../../App";

export async function fetchTravelServices() {
  return await authorizedAxios.get(
    `${VALAQUENTA_API_URL}/crm/travel-services/`
  );
}
